import store from '@/store'
import lib from '@/library'
import JWTdecode from 'jwt-decode'

/* communication between App (webview, wrappper) and Web; those methods will be used from the App */
function init () {
  window.mobileBridge = (function () {
    console.log('Mobile Bridge initialized')
    siteLoaded() // site loaded, inform the app
    return {
      userVerified: function (data) {
        console.log('user Verified')
        console.log(data)
        data['faceId'] = true
        store.dispatch('igtcServiceLogin', data)
      },
      /* may choose to remember the progress state ; may choose to show a progress dialog / banner to the user */
      geolocationInProgress: function () {
        console.log('-- geolocationInProgress --')
        store.commit('setMobileGeolocationInProgress', {'display': true, 'inProgress': true, 'postContentFailed': false, 'isFirstCheck': true})
      },
      /* present notification bar for geolocation failure. On tapping view details, present a single error alert with the data supplied by the errorJSON */
      geolocationFailed: function (data) {
        console.log('geolocationFailed')
        store.commit('setMobileGeolocationInProgress', {'display': true, 'inProgress': false, 'postContentFailed': true, 'count': data.count, 'retryCount': 1, 'id': data.id})
        // displayError(errorCode, errorJSON)
      },
      /* save JWT for subsequent wallet requests ; look inside JWT for success/failure and troubleshooter message extraction */
      geolocationAvailable: function (state, jwt) {
        console.log('geolocationAvailable')
        console.log(state)
        console.log(jwt)
        decodeJWT(jwt)
      },
      /* may choose to remember the state ; may choose to notify user of redirect ; will redirect the user or ensure correct content */
      stateAvailable: function (state) {
        console.log('stateAvailable')
        console.log(state)
        // errorCode = 'mobileAppRedirect'
        // data = { 'state': state }
        // setGeolocation(false)
        // store.commit('overlayState/setGeolocationMessage', { errorCode, data })
        // store.dispatch('overlayState/activeGeolocationDialog')
      },
      locationVerified: function () {
        locationVerified()
      },
      /* alert user of error based on type and message - likely presenting a dialog due to the unspecified nature of the failure */
      unexpectedError: function (errorMessage) {
        console.log('unexpectedError')
        console.log(errorMessage)
        // errorCode = 'mobileAppUnexpectedError'
        // data = { 'message': errorMessage }
        // setGeolocation(false)
        // store.commit('overlayState/setGeolocationMessage', { errorCode, data })
        // store.dispatch('overlayState/activeGeolocationDialog')
      },
      removeNotificationBar: function () {
        console.log('removeNotificationBar')
        store.commit('setMobileGeolocationInProgress', { 'display': false })
      },
      /* App tell Web to logout user (f.e: adapter inform app about session expiration during geolocation process) */
      logoutUser: function () {
        store.dispatch('logout')
      }
    }
  })()
}

const userAgent = function () {
  let name = lib.core.userAgent.os.name
  return name
}

function mobileUserLogin (response, password) {
  try {
    response.result['password'] = password
    let result = JSON.stringify(response.result)
    if (userAgent() === 'ios') {
      window.webkit.messageHandlers.mobileLogin.postMessage(result)
    }
    if (userAgent() === 'android') {
      /* eslint-disable */
      android.mobileLogin(result)
      /* eslint-enable */
    }
  } catch (error) {
    console.error('error')
  }
}
function siteLoaded () {
  try {
    if (userAgent() === 'ios') {
      window.webkit.messageHandlers.siteLoaded.postMessage('site loaded')
    }
    if (userAgent() === 'android') {
      /* eslint-disable */
      android.siteLoaded('site loaded')
      /* eslint-enable */
    }
  } catch (error) {
    console.error('error')
  }
}

function showLocationMessage (id) {
  try {
    if (userAgent() === 'ios') {
      window.webkit.messageHandlers.showLocationMessage.postMessage(id)
    }
    if (userAgent() === 'android') {
      /* eslint-disable */
      android.showLocationMessage(id)
      /* eslint-enable */
    }
  } catch (error) {
    console.error('error')
  }
}

function mobileLogout () {
  localStorage.mobileGeolocated = false
  try {
    store.commit('setMobileGeolocationInProgress', { 'display': false })
    if (userAgent() === 'ios') {
      window.webkit.messageHandlers.mobileLogout.postMessage()
    }
    if (userAgent() === 'android') {
      /* eslint-disable */
      android.mobileLogout()
      /* eslint-enable */
    }
  } catch (error) {
    console.error('error')
  }
}
function mobileDownloadPdf (url) {
  try {
    if (userAgent() === 'ios') {
      window.webkit.messageHandlers.mobileDownloadPdf.postMessage(url)
    }
    if (userAgent() === 'android') {
      /* eslint-disable */
      android.mobileDownloadPdf(url)
      /* eslint-enable */
    }
  } catch (error) {
    console.error('error')
  }
}
function openLink (link) {
  console.log('link', link)
  try {
    if (userAgent() === 'ios') {
      window.webkit.messageHandlers.openLink.postMessage(link)
    }
    if (userAgent() === 'android') {
      /* eslint-disable */
      android.openLink(link)
      /* eslint-enable */
    }
  } catch (error) {
    console.error('error')
  }
}

function setGeolocation (isGeolocated) {
  localStorage.mobileGeolocated = isGeolocated
  store.commit('setGeolocated', isGeolocated)
  if (!isGeolocated) {
    store.commit('setGeolocated', false)
  }
}

/* decrypt jwt and read gelocation status */
function decodeJWT (token) {
  localStorage.mobileToken = token
  let decodeResponse = JWTdecode(token)
  console.log('mobile jwt decode')
  console.log(decodeResponse)
  if (decodeResponse.result) {
    locationVerified(decodeResponse)
  }
  if (!decodeResponse.result) {
    locationFailed(decodeResponse)
  }
}

function locationVerified () {
  console.log('locationVerified')
  setGeolocation(true)
  store.commit('setMobileGeolocationInProgress', {'display': true, 'inProgress': false, 'postContentSuccess': true, 'isFirstCheck': true})
  setTimeout(() => {
    store.commit('setMobileGeolocationInProgress', {'display': false})
  }, 2000)
}

function locationFailed (response) {
  console.log('locationFailed')
  console.log(response)
  // displayGeolocationError(response.troubleshooter)
}

/* display single error (network issue, GPS disabled, etc) */
/*
function displayError (code, errorJSON) {
  setGeolocation(false)
  console.log('errorJSON.cta_text')
  console.log(errorJSON.cta_text)
  message = errorJSON.message
  title = (errorJSON.title !== '' || errorJSON.title !== undefined) ? errorJSON.title : 'We cannot verify your location'
  buttonText = (errorJSON.cta_text !== undefined && errorJSON.cta_text !== '') ? errorJSON.cta_text : 'Retry'
  buttonAction = (errorJSON.cta_action !== undefined && errorJSON.cta_action !== '') ? 'window.' + errorJSON.cta_action : "window.Wrapper.geolocateUser('Retry Geolocation')"
  retry = errorJSON.retry
  rule = errorJSON.rule
  console.log(code + ' - ' + title + ' - ' + buttonText + ' - ' + buttonAction)
  let data = { 'count': 1, 'errorType': 'singleMobileError', 'errors': {title, message, buttonText, buttonAction, rule}, 'retry': retry, 'payload': errorJSON }
  console.log('DATA')
  console.log(data)

  let errorCode = 'mobileGeoResponse'
  store.commit('overlayState/setGeolocationMessage', { errorCode, data })
}
*/

/* errors received from GeoComply service ; single or multi errors */
/*
function displayGeolocationError (troubleshooter) {
  console.log('displayGeolocationError')
  console.log(troubleshooter)
  setGeolocation(false)
  let troubleLength = troubleshooter.length
  let retry = true
  for (let trouble of troubleshooter) { // if even one message has retry 'false', disable retry for all.
    if (!trouble.retry) {
      retry = false
      break
    }
  }
  let data = { 'count': troubleLength, 'errorType': 'mobileGeolocationError', 'errors': troubleshooter, 'retry': retry, 'payload': troubleshooter }
  let errorCode = 'mobileGeoResponse'
  store.commit('overlayState/setGeolocationMessage', { errorCode, data })
  store.commit('setMobileGeolocationInProgress', {'display': true, 'inProgress': false, 'postContentFailed': true, 'count': troubleLength, 'retry': retry})
}
*/
export default {
  init,
  mobileUserLogin,
  showLocationMessage,
  mobileLogout,
  mobileDownloadPdf,
  openLink
}



// WEBPACK FOOTER //
// ./src/library/mobileBridge/index.js